export default __webpack_public_path__ + "static/media/chat-block3.6dd0d27d.png";